import isBrowser from "./isBrowser";

export const DateOptions: Intl.DateTimeFormatOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  timeZone: isBrowser() ? undefined : "Europe/Copenhagen",
} as const;
